import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

/**
 * @function SimpleInfoDialog
 * @param {Boolean}          open   - Whether the dialog is visible
 * @param {Function}         close  - Function to close the dialog
 * @param {String}           title  - Translation key for the title
 * @param {String}           [text] - Translation key for a single content line
 * @param {String[]}         [texts] - Array of translation keys for multiple lines
 */
const SimpleInfoDialog = ({ open, close, title, text, texts }) => {
  const { t } = useTranslation();

  const lines = texts ?? (text ? [text] : []);

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>{t(title)}</DialogTitle>
      <DialogContent>
        {lines.map((key) => (
          <DialogContentText key={key}>{t(key)}</DialogContentText>
        ))}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={close}>
          {t("forms.shorelineAnalysis.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SimpleInfoDialog;